import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError('');
    try {
      const params = new URLSearchParams();
      params.append('username', email);
      params.append('password', password);
      const res = await API.post('/auth/login', params);
      login(res.data.access_token, res.data.usuario);
      navigate('/dashboard');
    } catch (err) {
      setError('Email o contraseña incorrectos');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>Tempo<span style={styles.logoDot}>.</span>Gestión</div>
        <p style={styles.subtitle}>Accede a tu cuenta</p>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="tu@empresa.com"
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Contraseña</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button style={cargando ? styles.btnDisabled : styles.btn} type="submit" disabled={cargando}>
            {cargando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p style={styles.footer}>
          ¿No tienes cuenta? <Link to="/registro" style={styles.link}>Regístrate gratis</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f3' },
  card: { background: 'white', borderRadius: 12, border: '0.5px solid #e0e0d8', padding: '40px 36px', width: '100%', maxWidth: 400 },
  logo: { fontSize: 22, fontWeight: 500, color: '#1a1a1a', marginBottom: 6, textAlign: 'center' },
  logoDot: { color: '#378ADD' },
  subtitle: { fontSize: 14, color: '#888', textAlign: 'center', marginBottom: 28 },
  error: { background: '#FCEBEB', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, color: '#444', marginBottom: 6, fontWeight: 500 },
  input: { width: '100%', padding: '9px 12px', borderRadius: 8, border: '0.5px solid #d0d0c8', fontSize: 14, outline: 'none', boxSizing: 'border-box', background: 'white', color: '#1a1a1a' },
  btn: { width: '100%', padding: '10px', borderRadius: 8, background: '#378ADD', color: 'white', border: 'none', fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 8 },
  btnDisabled: { width: '100%', padding: '10px', borderRadius: 8, background: '#a0c4e8', color: 'white', border: 'none', fontSize: 14, fontWeight: 500, cursor: 'not-allowed', marginTop: 8 },
  footer: { fontSize: 13, color: '#888', textAlign: 'center', marginTop: 20 },
  link: { color: '#378ADD', textDecoration: 'none', fontWeight: 500 },
};
